'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';
import type { EmblaCarouselType } from 'embla-carousel';
export type UseDotButtonType = {
  selectedIndex: number;
  scrollSnaps: number[];
  onPaginationButtonClick: (index: number) => void;
};
export function useCarouselPaginationButtons(emblaApi) {
  const $ = _c(11);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t0;
  if ($[0] !== emblaApi) {
    t0 = index => {
      if (!emblaApi) {
        return;
      }
      emblaApi.scrollTo(index);
    };
    $[0] = emblaApi;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onPaginationButtonClick = t0;
  let t1;
  let t2;
  if ($[2] !== emblaApi) {
    t1 = () => {
      if (!emblaApi) {
        return;
      }
      const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
      emblaApi.on("reInit", onSelect).on("select", onSelect);
      return () => {
        emblaApi.off("reInit", onSelect).off("select", onSelect);
      };
    };
    t2 = [emblaApi];
    $[2] = emblaApi;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== emblaApi) {
    t3 = emblaApi?.scrollSnapList() ?? [];
    $[5] = emblaApi;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onPaginationButtonClick || $[8] !== selectedIndex || $[9] !== t3) {
    t4 = {
      selectedIndex,
      scrollSnaps: t3,
      onPaginationButtonClick
    };
    $[7] = onPaginationButtonClick;
    $[8] = selectedIndex;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
type CarouselPaginationButtonProps = ButtonProps & {
  active?: boolean;
};
export function CarouselPaginationButton(t0) {
  const $ = _c(11);
  let active;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      active,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = children;
    $[3] = props;
  } else {
    active = $[1];
    children = $[2];
    props = $[3];
  }
  const t1 = active ? "var(--mui-palette-common-white)" : "transparent";
  const t2 = active ? "scale(1.4)" : "scale(1)";
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      width: "14px",
      height: "14px",
      border: "2px solid #fff",
      transition: ".3s all ease",
      borderRadius: "50%",
      display: "block",
      padding: 0,
      margin: 0,
      minWidth: 0,
      boxShadow: "var(--mui-shadows-2)",
      background: t1,
      transform: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== props || $[9] !== t3) {
    t4 = <Button sx={t3} {...props}>{children}</Button>;
    $[7] = children;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}